// extracted by mini-css-extract-plugin
export default {"relative":"VideoModal_relative__QhrtO","play":"VideoModal_play__f-OGN","custom":"VideoModal_custom__L6RgD"};